import React from 'react';
import imagenTrabajador from "../assets/images/about_client.jpg"
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import CardImagenes from './card';
import CardValidacion from './card_validaciones';
import ClientesCarousel from './clientesCarousel';
import FloatingButton from './buttonFlotanteWha';
import V1 from "../assets/images/validaciones/v1.png"
import V2 from "../assets/images/validaciones/v2.png"
import V3 from "../assets/images/validaciones/v3.png"
import S1 from "../assets/images/nuestrosServicios/s1.png"
import S2 from "../assets/images/nuestrosServicios/s2.png"
import S3 from "../assets/images/nuestrosServicios/s3.png"
import S4 from "../assets/images/nuestrosServicios/s4.png"
import S5 from "../assets/images/nuestrosServicios/s5.png"
import S6 from "../assets/images/nuestrosServicios/s6.png"
import S7 from "../assets/images/nuestrosServicios/s7.png"
import S8 from "../assets/images/nuestrosServicios/10.png"
import S9 from "../assets/images/nuestrosServicios/11.png"
import fondo from "../assets/images/fondo4.png";
import { useNavigate } from "react-router-dom";



function Nosotros(){
    const [animationKey, setAnimationKey] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
      const interval = setInterval(() => {
        setAnimationKey((prevKey) => prevKey + 1);
      }, 5000);
      return () => clearInterval(interval);
    }, []);
    
    const handleButtonClick = (op) => {
        switch(op){
          case 1:
            navigate("/certificaciones");
            break;
          case 2: 
          navigate("/capacitaciones");
            break;
          case 3: 
            navigate("/otros-servicios");
              break;
        default:
        alert("Opción no válida");
        }
    };




    return (
      
        <section className='flex flex-col items-center p-10 space-y-10'>
          {/* Header Section */}
          <div className='flex flex-col items-center text-center w-full'>
            <h1 className='text-azul-oscuro text-2xl uppercase font-bold hover:text-oro transition-colors duration-300'>
              Nosotros
            </h1>
            <div className='bg-oro h-1 w-32 my-3'></div>
            <p className='text-gris-oscuro font-medium text-lg'>
              Somos líderes regionales y mantenemos operaciones en Perú, Colombia, México y los Estados Unidos.
            </p>
          </div>
          
          {/* Content Section */}
          <div className='flex flex-col md:flex-row items-center justify-center w-full space-y-6 md:space-y-0 md:space-x-8'>
            <div className='flex-1'>
              <h1 className='text-azul-oscuro text-2xl uppercase font-bold mb-3'>
                ¿Quiénes Somos?
              </h1>
              <p className='text-gris-oscuro text-justify font-medium leading-relaxed '>
                Somos líderes en capacitación, entrenamiento, evaluación y certificación de operadores, maquinaria pesada y todo tipo de grúas industriales a nivel nacional e internacional, respetando puntualmente las normas internacionales como ASME, ANSI, AWS, BSI, DIN, ISO, OSHA, MSHA, AS y más.
                Nuestro enfoque innovador nos mantiene como referentes en la especialización de operadores de maquinaria pesada.
              </p>
            </div>
            
            <div className='flex-2'>
              <img 
                src={imagenTrabajador}
                alt='Trabajador'
                className='w-80 h-80 object-cover rounded-lg shadow-xl hover:scale-105 transition-transform duration-500 border-4 border-oro'
              />
            </div>
          </div>
 {/* Statistics Section */}


<div 
  className='relative flex flex-col md:flex-row justify-center w-full space-y-6 md:space-y-0 md:space-x-8 bg-azul-oscuro p-10 rounded-lg shadow-lg overflow-hidden'
>
  {/* Capa de fondo con opacidad */}
  <div 
    className="absolute inset-0 bg-cover bg-center " 
    style={{ backgroundImage: `url(${fondo})` }}
  ></div>

  {/* Contenido con animación */}
  <div className="relative z-10 flex flex-col md:flex-row justify-center w-full space-y-6 md:space-y-0 md:space-x-8">
    {[
      { number: "+100", text: "Certificaciones" },
      { number: "+100", text: "Clientes Satisfechos" },
      { number: "+100", text: "Capacitaciones" },
      { number: "+5", text: "Años de experiencia" }
    ].map((item, index) => (
      <motion.div 
        key={`${animationKey}-${index}`}
        initial={{ opacity: 0, y: 50 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 1, delay: index * 0.3 }}
        className='flex flex-col items-center text-center px-10 py-5'
      >
        <h2 className='text-gris-claro font-bold text-4xl mb-2'>{item.number}</h2>
        <h1 className='text-gris-claro font-semibold text-xl'>{item.text}</h1>
      </motion.div>
    ))}
  </div>
</div>

      {/* card Section */}

      <div className='flex flex-col  w-full'>
            <h1 className='text-azul-oscuro text-2xl uppercase font-bold hover:text-oro transition-colors duration-300'>
              Nuestros servicios
            </h1>
            <div className='bg-oro h-1 w-64 my-3'></div>
            <div className="flex flex-wrap justify-center gap-20 p-4">
                {[
                  { title: "CERTIFICACIÓN  PARA EQUIPOS PESADOS", img: S1,op:1 },
                  { title: "CERTIFICACIÓN PARA EQUIPOS DE IZAJE", img: S2,op:1  },
                  { title: "CERTIFICACIÓN  DE OPERADORES ", img: S3,op:1  },
                  { title: "CURSO DE PERFORACIÓN Y VOLADURA", img: S4,op:2 },
                  { title: "CERTIFICACIÓN DE SUPERVISORES DE IZAJE", img: S5,op:1},
                  { title: "CONSULTORÍAS", img: S6,op:3 },
                  { title: "MANTENIMIENTOS", img: S7,op:2  },
                  { title: "SISTEMA DE GESTIÓN ", img: S8 ,op:3},
                  { title: "otros servicios", img: S9 ,op:3},
                ].map((item, index) => (
                  <CardImagenes key={index} imagenurl={item.img} title={item.title}>
                    <button
                      onClick={() => handleButtonClick(item.op)}
                      className="bg-oro hover:bg-azul-oscuro text-white font-semibold py-2 px-4 rounded transition-all duration-300"
                    >
                      Ver más
                    </button>
                  </CardImagenes>
                ))}
              </div>
          </div>
 {/*   Validaciones internacionales */}
          <div className='flex flex-col  w-full'>
            <h1 className='text-azul-oscuro text-2xl uppercase font-bold hover:text-oro transition-colors duration-300'>
             Validaciones internacionales
            </h1>
            <div className='bg-oro h-1 w-80 my-3'></div>
            <div className="flex flex-wrap justify-center gap-20 p-8">
            {[
                  { title: "QUALITY LATINOAMERICA", img: V1},
                  { title: "CRANES AND ENGINEERING & OPERATOR", img: V2},
                  { title: "International Association of Drilling Contractors", img: V3 },
                  
                ].map((item, index) => (
                  <CardValidacion key={index} imagenurl={item.img} title={item.title}>
                    
                  </CardValidacion>
                ))}
              </div>
          </div>
           {/*   Clientes */}
          <div className='flex flex-col  w-full'>
            <h1 className='text-azul-oscuro text-2xl uppercase font-bold hover:text-oro transition-colors duration-300'>
            Clientes Satisfechos
            </h1>
            <div className='bg-oro h-1 w-64 my-3'></div>
            <ClientesCarousel/>
          </div>
           {/*   Validaciones internacionales */}
           <div>
            
           </div>
           <FloatingButton/>

        </section>
      );
      
}
export default Nosotros;